module.exports = __webpack_public_path__ + "2c95ab97176054b5f01aacee655c05fb.MP3";